enum Role {
    APP_ADMIN = 'admin',
    COMPANY_ADMIN = 'admin:company',
    USER = 'dashboards:read',
}

export default Role;
